"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendVerificationEmailArgsValidator = exports.sendVerificationEmailArgsSchema = exports.sendSignInEmailArgsValidator = exports.sendSignInEmailArgsSchema = exports.completeSignUpArgsValidator = exports.completeSignUpArgsSchema = exports.updateNameArgsValidator = exports.updateNameArgsSchema = exports.updateEmailArgsValidator = exports.updateEmailArgsSchema = exports.emailValidator = exports.displayNameValidator = exports.nameValidator = void 0;
var suretype_1 = require("suretype");
var nameSchema = suretype_1.v.string().minLength(1).maxLength(18).required();
exports.nameValidator = (0, suretype_1.compile)(nameSchema);
var displayNameSchema = suretype_1.v.string().minLength(1).maxLength(40);
exports.displayNameValidator = (0, suretype_1.compile)(displayNameSchema);
var emailSchema = suretype_1.v.string().format("email").maxLength(60).required();
exports.emailValidator = (0, suretype_1.compile)(emailSchema);
// ==========================
// update
// ==========================
exports.updateEmailArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("updateEmail").required(),
    email: emailSchema
});
exports.updateEmailArgsValidator = (0, suretype_1.compile)(exports.updateEmailArgsSchema);
exports.updateNameArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("updateName").required(),
    firstName: nameSchema,
    lastName: nameSchema,
});
exports.updateNameArgsValidator = (0, suretype_1.compile)(exports.updateNameArgsSchema);
exports.completeSignUpArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("updateName").required(),
    givenName: nameSchema,
    familyName: nameSchema,
    displayName: displayNameSchema.required()
});
exports.completeSignUpArgsValidator = (0, suretype_1.compile)(exports.completeSignUpArgsSchema);
// ==========================
// send emails
// ==========================
exports.sendSignInEmailArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("mergeUserSecrets").required(),
    email: emailSchema,
    app: suretype_1.v.string().enum("desktopBrowser", "desktopApp").required()
});
exports.sendSignInEmailArgsValidator = (0, suretype_1.compile)(exports.sendSignInEmailArgsSchema);
exports.sendVerificationEmailArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("sendVerificationEmail").required(),
    email: emailSchema
});
exports.sendVerificationEmailArgsValidator = (0, suretype_1.compile)(exports.sendVerificationEmailArgsSchema);
